module.exports = __webpack_public_path__ + "img/pasture_buffel.83b89cbb.jpg";